/* ALAC home page buy box. Markup: sections/feature-products-homepage-c.liquid.
   Pricing labels reuse window.alacValue from alac-pdp-value.js so the home page and product page agree. */
(function () {
  'use strict';
  const FORMAT_ORDER = ['12oz', '5lbs', 'kcups', 'steepbag'];
  const FORMAT_LABEL = { '12oz': '12oz', '5lbs': '5lbs', kcups: 'K-Cups', steepbag: 'Steep Bags' };
  const GRIND_LABEL = { ground: 'Ground', wholebean: 'Whole Bean' };
  // Bulk packs stay on the product page; the home page shows the everyday sizes.
  const HIDDEN_VARIANT = /^\s*12\s*bags?\b|144\s*cups/i;
  const cache = new Map();
  // Used only if alac-pdp-value.js failed to load; same rules as that file (kept in sync by tests).
  const FALLBACK = {
    units(product, variant) {
      const title = product.title.toLowerCase();
      const count = Number((variant.title.match(/^\s*(\d+)/) || [])[1] || 1);
      if (/steep bags/.test(title)) return { count: /10.pack/i.test(variant.title) ? 10 : 1, noun: 'serving', estimated: false };
      if (/cups/.test(title) && !/reusable/.test(title)) { const c = variant.title.match(/(\d+)\s*cups/i); return c ? { count: Number(c[1]), noun: 'cup', estimated: false } : null; }
      if (/12oz/.test(title)) return { count: count * 340.194 / 15, packs: count, noun: 'cup', estimated: true };
      if (/5lbs/.test(title)) return { count: count * 2267.96 / 15, packs: count, noun: 'cup', estimated: true };
      return null;
    },
    quote(product, variant, planId, quantity) {
      const allocation = planId ? variant.allocations.find(a => String(a.id) === String(planId)) : null;
      if (planId && !allocation) return null;
      const price = allocation ? allocation.price : variant.price;
      return { price, total: price * quantity, serving: FALLBACK.units(product, variant), allocation };
    },
    variantCanSubscribe(variant) { return variant.allocations.length > 0; },
    renewalText(allocation, total, money) {
      if (!allocation) return '';
      const cadence = String(allocation.name || '').match(/\b(\d+)\s*weeks?\b/i);
      const frequency = cadence ? cadence[1] + ' weeks' : String(allocation.name || '').replace(/^\s*delivery every\s*/i, '').trim().toLowerCase();
      return 'Renews ' + (frequency ? 'every ' + frequency + ' ' : '') + 'at ' + money(total) + ', plus any shipping and tax, until you cancel. Skip, change or cancel any time.';
    },
    shippingGuidance(total, threshold, currency, money) {
      if (currency !== 'USD' || !(threshold > 0) || !Number.isFinite(total) || total < 0) return 'Shipping options at checkout.';
      const minimum = money(threshold).replace(/\.00(?=\D*$)/, '');
      return (total >= threshold ? 'Free Regular shipping*: this selection reaches the ' + minimum + ' minimum.' : 'This selection is ' + money(threshold - total) + ' short of free Regular shipping at ' + minimum + '.') + ' *Contiguous US orders qualify when the order total after discounts stays at or above ' + minimum + '.';
    },
    cadenceGuidance(total, threshold, currency) {
      return currency === 'USD' && threshold > 0 && total < threshold
        ? 'A larger pack may help you reach the minimum; choose a delivery interval that matches your routine.'
        : 'Space deliveries to match how quickly you use this pack.';
    },
    packCount(title) { const t = String(title || '').trim(); if (/^one\b/i.test(t)) return 1; const n = Number((t.match(/^(\d+)/) || [])[1]); return n > 0 ? n : 1; },
    recommendBadge(count, price, isBag12, threshold, currency, money) { if (count !== 3) return null; const reaches = currency === 'USD' && threshold > 0 && price >= threshold; if (!isBag12 && !reaches) return null; return reaches ? 'Recommended · ' + money(threshold).replace(/\.00(?=\D*$)/, '') + '+' : 'Recommended'; },
    tileSavings(tiles) {
      const single = tiles.find(t => t.count === 1);
      if (!single) return tiles.map(() => null);
      const per = tiles.map(t => t.price / t.count); const best = Math.min(...per);
      return tiles.map((t, i) => { if (t.count === 1) return null; const save = single.price * t.count - t.price; if (save < 50) return null; return { save, pct: Math.round(save / (single.price * t.count) * 100), best: per[i] === best }; });
    }
  };

  function handleFromUrl(url) {
    try {
      const match = new URL(url, 'https://store.example').pathname.match(/(?:^|\/)products\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) { return null; }
  }
  function sized(src) {
    if (!src) return null;
    if (/[?&]width=/.test(src)) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
  }
  function baseName(src) { return String(src || '').split('?')[0].split('/').pop(); }
  function escapeHtml(value) { return String(value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]); }
  function galleryAlt(product, alts, src, index, total) {
    const stored = alts.find(image => baseName(image.src) === baseName(src))?.alt;
    return stored && stored.trim() ? stored.trim() : product.title + ', product image ' + (index + 1) + ' of ' + total;
  }
  function orderSummary({ handle, variantId, quantity, subscription, planId, selection, unitPrice, cadence }, money) {
    return {
      key: [handle, variantId, quantity, subscription, planId || ''].join(':'),
      text: (subscription ? 'Subscription' : 'One-time purchase') + ', ' + selection + ', '
        + money(unitPrice * quantity) + (subscription ? ' per delivery' : ' total')
        + (cadence ? ', every ' + cadence + ' weeks' : '') + '.'
    };
  }
  function createOrderAnnouncer(write) {
    let previousKey;
    return {
      prime(order) { previousKey = order.key; },
      announce(order) {
        if (order.key === previousKey) return false;
        previousKey = order.key;
        write(order.text);
        return true;
      }
    };
  }
  function normalize(json) {
    const groups = {};
    (json.selling_plan_groups || []).forEach(g => (g.selling_plans || []).forEach(sp => { groups[sp.id] = sp.name; }));
    return {
      handle: json.handle,
      url: json.url || '/products/' + json.handle,
      title: json.title,
      images: (json.images || []).slice(0, 8).map(sized),
      imageAlts: (json.media || []).map(m => ({ src: m.src || m.preview_image?.src, alt: m.alt || '' })),
      variants: json.variants.map(v => ({
        id: v.id, title: v.title, price: v.price, available: v.available,
        // Unit grams and shipping, for the delivery estimate card (pushDelivery).
        weight: Number(v.weight) || 0, requiresShipping: v.requires_shipping !== false,
        image: v.featured_image ? sized(v.featured_image.src) : null,
        allocations: (v.selling_plan_allocations || []).map(a => ({ id: a.selling_plan_id, name: groups[a.selling_plan_id] || '', price: a.price })).filter(a => window.AlacSubscriptionPricing?.storefrontPlan(a))
      }))
    };
  }
  function requestProduct(url, fetcher, timeoutMs) {
    const controller = new AbortController();
    let timer;
    const expired = new Promise((_, reject) => {
      timer = setTimeout(() => {
        reject(new Error('Selection request timed out'));
        controller.abort();
      }, timeoutMs == null ? 8000 : timeoutMs);
    });
    const request = Promise.resolve().then(() => fetcher(url, { credentials: 'same-origin', signal: controller.signal }))
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    // Bound the entire response, including JSON, so a stalled response releases the choices.
    return Promise.race([request, expired]).finally(() => clearTimeout(timer));
  }
  function detailsUrl(productUrl, variantId, quantity, planId) {
    const url = new URL(productUrl, 'https://store.example');
    url.searchParams.set('variant', String(variantId));
    if (quantity > 1) url.searchParams.set('quantity', String(quantity));
    else url.searchParams.delete('quantity');
    if (planId) url.searchParams.set('selling_plan', String(planId));
    else url.searchParams.delete('selling_plan');
    return /^https?:\/\//i.test(productUrl) ? url.href : url.pathname + url.search + url.hash;
  }
  function imageWidth(src, width) {
    try {
      const url = new URL(src, 'https://store.example');
      if (!/^https?:$/.test(url.protocol)) return null;
      url.searchParams.set('width', String(width));
      if (src.startsWith('//')) return '//' + url.host + url.pathname + url.search;
      return /^https?:\/\//i.test(src) ? url.href : url.pathname + url.search;
    } catch (_) { return null; }
  }
  function galleryLoading(first, userSelection, inViewport) {
    return first && (userSelection || inViewport) ? 'eager' : 'lazy';
  }
  function relatedChoice(related, current, group, selected, defaultGrind) {
    const type = group === 'format' ? selected : current.type;
    const grind = group === 'grind' ? selected : type === '12oz' || type === '5lbs' ? current.grind || defaultGrind || 'ground' : null;
    return related.find(r => r.type === type && r.grind === grind) || (group === 'format' && related.find(r => r.type === type));
  }
  function load(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const promise = requestProduct(root + 'products/' + encodeURIComponent(handle) + '.js', window.fetch.bind(window))
      .then(normalize)
      .catch(err => { cache.delete(handle); throw err; });
    cache.set(handle, promise);
    return promise;
  }

  function visibleVariants(product) {
    const list = product.variants.filter(v => !HIDDEN_VARIANT.test(v.title) && v.title !== '1 Steep Bag');
    return list.length ? list : product.variants.slice(0, 1);
  }
  function availableSingle(product, packCount) {
    return product.variants.find(v => !HIDDEN_VARIANT.test(v.title) && packCount(v.title) === 1 && v.available);
  }
  function hasSteepSingle(product) { return product.variants.some(v => v.title === '1 Steep Bag'); }
  function singleQuantityProduct(product) { return visibleVariants(product).length === 1 && !hasSteepSingle(product); }
  function defaultVariant(product, keepCount, packCount) {
    const list = visibleVariants(product);
    return (keepCount && list.find(v => packCount(v.title) === keepCount && v.available)) ||
      list.find(v => v.available) || list[0];
  }
  function matchingRelated(related, previous) {
    return previous && (related.find(r => r.type === previous.type && r.grind === previous.grind) ||
      related.find(r => r.type === previous.type));
  }
  function quantityTiles(product, variants, cadence, isSubscribed, value, pricing) {
    return variants.map(v => {
      const plan = isSubscribed && cadence ? v.allocations.find(a => pricing.weeks(a.name) === cadence) || null : null;
      const quote = value.quote(product, v, plan?.id, 1) || value.quote(product, v, null, 1);
      return { v, count: value.packCount(v.title), price: quote.price, serving: quote.serving, plan };
    });
  }
  function comparableSavings(tiles, isSubscribed, value) {
    const comparable = tiles.filter(tile => tile.v.available && (!isSubscribed || tile.plan));
    const savings = value.tileSavings(comparable);
    return new Map(comparable.map((tile, i) => [tile.v.id, savings[i]]));
  }
  function customQuantityIntent(product, custom, quantity) {
    return custom || (singleQuantityProduct(product) && quantity > 1);
  }
  function orderQuantity(product, custom, quantity) {
    return !singleQuantityProduct(product) && !custom ? 1 : quantity;
  }
  function hasSubscriptionSaving(variant, plan) { return !!plan && plan.price < variant.price; }

  function init(root) {
    if (root.dataset.hbReady) return;
    root.dataset.hbReady = '1';
    const V = Object.assign({}, FALLBACK, window.alacValue || {});
    let data;
    try { data = JSON.parse(root.querySelector('[data-hb-data]').textContent); } catch (_) { return; }
    if (!data.tabs.length) return;
    const $ = sel => root.querySelector(sel);
    const money = cents => new Intl.NumberFormat(data.locale || 'en', { style: 'currency', currency: data.currency || 'USD' }).format(cents / 100);
    const els = {
      tabs: [...root.querySelectorAll('[role="tab"]')],
      panel: $('[role="tabpanel"]'),
      intros: [...root.querySelectorAll('[data-hb-intro]')],
      format: $('[data-hb-opts="format"]'), grind: $('[data-hb-opts="grind"]'), qty: $('[data-hb-opts="qty"]'),
      grindGroup: $('[data-hb-group="grind"]'), formatGroup: $('[data-hb-group="format"]'),
      stepper: $('[data-hb-stepper]'), stepperLabel: $('[data-hb-stepper-label]'), qtyInput: $('[data-hb-qty-input]'), other: $('[data-hb-other]'),
      once: $('input[value="buyonce"]'), sub: $('input[value="subscribeandsave"]'), subWrap: $('[data-hb-sub-wrap]'),
      priceOnce: $('[data-hb-price="once"]'), priceSub: $('[data-hb-price="sub"]'),
      pct: $('[data-hb-sub-pct]'), pctText: $('[data-hb-sub-pct-text]'), subSaving: $('[data-hb-sub-saving]'), freq: $('[data-hb-freq]'), plan: $('[data-hb-plan]'),
      id: $('[data-hb-input="id"]'), quantity: $('[data-hb-input="quantity"]'), planInput: $('[data-hb-input="plan"]'),
      atc: $('[data-hb-atc]'), renewal: $('[data-hb-renewal]'), details: $('[data-hb-details]'), status: $('[data-hb-status]'), orderStatus: $('[data-hb-order-status]'),
      track: $('[data-hb-track]'), dots: $('[data-hb-dots]'), thumbs: $('[data-hb-thumbs]')
    };
    const uid = root.id;
    const state = { tab: 0, product: null, entry: null, variantId: null, custom: false, qty: 1, previousPackCount: null, planId: null, pendingSelection: null, token: 0, groupKey: '', galleryKey: '' };

    data.tabs.forEach(t => {
      const p = t.product;
      p.variants.forEach(v => { v.allocations = (v.allocations || []).filter(a => window.AlacSubscriptionPricing?.storefrontPlan(a)); });
      cache.set(p.handle, Promise.resolve(p));
      t.base = handleFromUrl(p.url) || p.handle;
      t.related = (t.related || []).map(r => ({ type: String(r.Type || '').toLowerCase(), grind: r.Grind ? String(r.Grind).toLowerCase() : null, handle: handleFromUrl(r.Url) })).filter(r => r.handle && FORMAT_ORDER.includes(r.type));
      t.self = t.related.find(r => r.handle === t.base || r.handle === p.handle);
      if (!t.self) {
        const title = p.title.toLowerCase();
        const type = /5lbs/.test(title) ? '5lbs' : /cups/.test(title) ? 'kcups' : /steep/.test(title) ? 'steepbag' : '12oz';
        t.self = { type, grind: /whole bean/.test(title) ? 'wholebean' : type === '12oz' || type === '5lbs' ? 'ground' : null, handle: p.handle };
        // The metafield can point at an older handle for this same product; the inline product wins.
        t.related = t.related.filter(r => !(r.type === t.self.type && r.grind === t.self.grind));
        t.related.push(t.self);
      }
    });

    function tabData() { return data.tabs[state.tab]; }
    function currentVariant() { return state.product.variants.find(v => String(v.id) === String(state.variantId)) || visibleVariants(state.product)[0]; }
    function singleFor(product) { return availableSingle(product, V.packCount); }
    function subscribed() { return els.sub.checked && !els.sub.disabled; }
    function packNoun(product) { return /cups/i.test(product.title) ? 'box' : /steep bags/i.test(product.title) ? 'bag' : /variety pack/i.test(product.title) ? 'pack' : 'bag'; }
    function pieceLabel(product, variant) {
      const t = variant.title;
      if (/^default title$/i.test(t)) return /5lbs/i.test(product.title) ? '5lb bag' : '1 item';
      const cups = t.match(/(\d+)\s*cups/i);
      if (/cups/i.test(product.title) && cups) { const n = V.packCount(t); return n + (n === 1 ? ' Box' : ' Boxes'); }
      return t.replace(/\s+/g, ' ').trim();
    }
    function pieceSub(product, variant) {
      const cups = variant.title.match(/(\d+)\s*cups/i);
      return cups ? cups[1] + ' cups' : '';
    }

    // ---------- choice groups ----------
    function radio(group, value, label, opts) {
      const id = uid + '-' + group + '-' + value;
      return '<div class="alac-hb__opt"><input class="alac-hb__sr" type="radio" name="' + uid + '-' + group + '" id="' + id + '" value="' + value + '"' + (opts.checked ? ' checked' : '') + (opts.disabled ? ' disabled' : '') + '><label for="' + id + '" class="alac-hb__pill">' + label + '</label></div>';
    }
    function renderFormatGrind() {
      const t = tabData();
      const types = FORMAT_ORDER.filter(f => t.related.some(r => r.type === f));
      const grinds = ['ground', 'wholebean'].filter(g => t.related.some(r => r.grind === g));
      const e = state.entry;
      const key = state.tab + '|' + types.join() + '|' + grinds.join();
      if (els.format.dataset.key !== key) {
        els.format.dataset.key = key;
        els.format.style.setProperty('--hb-cols', Math.max(types.length, 1));
        els.format.innerHTML = types.map(f => radio('format', f, FORMAT_LABEL[f], {})).join('');
        els.grind.style.setProperty('--hb-cols', Math.max(grinds.length, 1));
        els.grind.innerHTML = grinds.map(g => radio('grind', g, GRIND_LABEL[g], {})).join('');
      }
      els.grindGroup.hidden = grinds.length === 0;
      els.format.querySelectorAll('input').forEach(i => { i.checked = i.value === e.type; });
      const noGrind = e.type === 'kcups' || e.type === 'steepbag';
      els.grind.querySelectorAll('input').forEach(i => {
        const exists = t.related.some(r => r.type === e.type && r.grind === i.value);
        i.disabled = noGrind || !exists;
        i.checked = !noGrind && i.value === e.grind;
      });
      els.grindGroup.classList.toggle('is-na', noGrind);
    }

    function renderQty() {
      const product = state.product;
      const selectedPlan = subscribed() ? currentVariant().allocations.find(a => String(a.id) === String(state.planId)) : null;
      const cadence = window.AlacSubscriptionPricing?.weeks(selectedPlan?.name);
      const variants = visibleVariants(product);
      const single = singleQuantityProduct(product);
      const tiles = quantityTiles(product, variants, cadence, subscribed(), V, window.AlacSubscriptionPricing);
      const key = product.handle + '|' + variants.map(v => v.id).join();
      if (els.qty.dataset.key !== key) {
        const hadFocus = els.qty.contains(document.activeElement);
        els.qty.dataset.key = key;
        els.qty.style.setProperty('--hb-cols', single ? 1 : variants.length);
        els.qty.innerHTML = single ? '' : variants.map(v => {
          const id = uid + '-qty-' + v.id;
          return '<div class="alac-hb__tile"><input class="alac-hb__sr" type="radio" name="' + uid + '-qty" id="' + id + '" value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            '<label for="' + id + '"><span class="alac-hb__band"><span class="alac-hb__tag" data-tag hidden></span></span><span class="alac-hb__tile-title">' + escapeHtml(pieceLabel(product, v)) + '</span>' +
            '<span class="alac-hb__tile-price" data-price></span><span class="alac-hb__tile-unit" data-unit></span><span class="alac-hb__tile-save" data-save></span><span class="alac-hb__tile-sub-save" data-sub-save></span></label></div>';
        }).join('');
        if (hadFocus) els.qty.querySelector('input:checked, input:not([disabled])')?.focus();
      }
      const noun = packNoun(product);
      const allowOther = !single && (variants.length >= 3 || hasSteepSingle(product)) && !!singleFor(product);
      els.qty.hidden = single;
      els.other.hidden = !allowOther;
      els.stepper.hidden = !(single || (allowOther && state.custom));
      els.other.setAttribute('aria-expanded', String(state.custom));
      els.other.textContent = state.custom ? 'Choose a pack size instead' : 'Other quantity';
      els.stepperLabel.textContent = single ? pieceLabel(product, variants[0]).replace(/^./, c => c.toUpperCase()) : 'Number of ' + noun + (noun === 'box' ? 'es' : 's');
      // A pack without the selected cadence changes to Buy once when chosen. Do not
      // compare its regular price with subscription prices or advertise another plan.
      const savings = comparableSavings(tiles, subscribed(), V);
      const isBag12 = /12oz/i.test(product.title) && !/cups|steep bags/i.test(product.title);
      tiles.forEach((tile, i) => {
        const input = els.qty.querySelector('input[value="' + tile.v.id + '"]');
        if (!input) return;
        const label = input.nextElementSibling;
        input.checked = !state.custom && tile.v.id === state.variantId;
        const saving = savings.get(tile.v.id);
        const badge = tile.v.available && (!subscribed() || tile.plan) ? V.recommendBadge(tile.count, tile.price, isBag12, Number(data.threshold) || 0, data.currency, money) : null;
        const strictBadge = badge && data.currency === 'USD' && Number(data.threshold) > 0 && tile.price >= Number(data.threshold) ? badge : null;
        label.querySelector('[data-price]').textContent = tile.v.available ? money(tile.price) : 'Sold out';
        label.querySelector('[data-unit]').textContent = tile.v.available ? (tile.serving ? (tile.serving.estimated ? '~' : '') + money(tile.price / tile.serving.count) + '/' + tile.serving.noun : pieceSub(product, tile.v)) : '';
        label.querySelector('[data-save]').textContent = !subscribed() && saving ? 'Save ' + money(saving.save) + ' (' + saving.pct + '%)' : '';
        const subscription = tile.plan;
        const subSaving = subscription && window.AlacSubscriptionPricing?.savings(tile.v.price, subscription.price);
        const offer = subscription && window.AlacSubscriptionPricing?.offer(product, tile.v, subscription);
        label.querySelector('[data-sub-save]').textContent = !tile.v.available ? '' : subscribed() && !subscription ? 'One-time only' : subscribed() && offer ? window.AlacSubscriptionPricing.tileSavings(offer, money) : subscribed() && subSaving ? 'Save ' + money(tile.v.price - subscription.price) + ' (' + subSaving.label + ')' : '';
        const tag = label.querySelector('[data-tag]');
        const tagText = strictBadge || (saving && saving.best ? 'Best value per ' + noun : '');
        tag.textContent = tagText; tag.hidden = !tagText;
        input.parentElement.classList.toggle('is-rec', !!strictBadge);
        input.parentElement.classList.toggle('is-best', !strictBadge && !!(saving && saving.best));
        input.setAttribute('aria-label', [pieceLabel(product, tile.v), label.querySelector('[data-price]').textContent, label.querySelector('[data-unit]').textContent, label.querySelector('[data-save]').textContent, label.querySelector('[data-sub-save]').textContent, tagText].filter(Boolean).join(', '));
      });
      els.qty.classList.toggle('has-tags', !!els.qty.querySelector('[data-tag]:not([hidden])'));
      equalizeBands();
      els.qtyInput.value = String(state.qty);
    }

    // A two-line badge in one tile must not push its price below the others.
    function equalizeBands() {
      const bands = [...els.qty.querySelectorAll('.alac-hb__band')];
      bands.forEach(b => { b.style.minHeight = ''; });
      if (!els.qty.classList.contains('has-tags')) return;
      const tallest = Math.max(0, ...bands.map(b => b.offsetHeight));
      if (tallest) bands.forEach(b => { b.style.minHeight = tallest + 'px'; });
    }
    // ---------- purchase type ----------
    // Reuse the existing order state and announce the visible guidance when it changes.
    const guidance = document.createElement('p');
    guidance.className = 'alac-hb__guidance';
    els.renewal.before(guidance);
    function renderGuidance() {
      const variant = currentVariant();
      const sub = subscribed();
      const plan = sub ? variant.allocations.find(a => String(a.id) === String(state.planId)) : null;
      if (root.getAttribute('aria-busy') === 'true') { guidance.textContent = ''; return; }
      if (!variant.available) { guidance.textContent = 'This selection is sold out.'; return; }
      if (sub && !plan) { guidance.textContent = 'Choose a delivery interval to confirm your subscription price.'; return; }
      const total = (plan ? plan.price : variant.price) * state.qty;
      const threshold = Number(data.threshold) || 0;
      guidance.textContent = V.shippingGuidance(total, threshold, data.currency, money) + (sub ? ' ' + V.cadenceGuidance(total, threshold, data.currency) : '');
    }

    function renderPurchase() {
      const product = state.product;
      const variant = currentVariant();
      const canSub = V.variantCanSubscribe(variant);
      els.sub.disabled = !canSub;
      els.subWrap.classList.toggle('is-disabled', !canSub);
      if (!canSub && els.sub.checked) els.once.checked = true;
      const allocs = variant.allocations;
      if (canSub) {
        const ids = allocs.map(a => String(a.id)).join();
        if (els.plan.dataset.key !== ids) {
          els.plan.dataset.key = ids;
          els.plan.replaceChildren(...allocs.map(a => {
            const option = document.createElement('option');
            option.value = String(a.id);
            option.textContent = window.AlacSubscriptionPricing?.weeks(a.name) ? window.AlacSubscriptionPricing.weeks(a.name) + ' Weeks' : String(a.name || '').replace(/^Delivery every\s*/i, '');
            return option;
          }));
        }
        if (!allocs.some(a => String(a.id) === String(state.planId))) {
          // Keep the same cadence when the format changes (plan ids differ per product).
          const prevName = state.planName;
          const match = prevName && allocs.find(a => window.AlacSubscriptionPricing?.weeks(a.name) === prevName);
          state.planId = (match || allocs[0]).id;
        }
        els.plan.value = String(state.planId);
        const a = allocs.find(x => String(x.id) === String(state.planId));
        state.planName = window.AlacSubscriptionPricing?.weeks(a.name) || a.name;
      }
      const qty = state.qty;
      els.priceOnce.textContent = money(variant.price * qty);
      const sub = canSub ? allocs.find(x => String(x.id) === String(state.planId)) : null;
      if (hasSubscriptionSaving(variant, sub)) {
        const offer = window.AlacSubscriptionPricing?.offer(state.product, variant, sub);
        const pct = offer?.total || window.AlacSubscriptionPricing?.savings(variant.price, sub.price)?.label || '';
        els.pct.textContent = offer ? pct + ' total' : pct;
        els.pctText.textContent = offer ? pct + ' vs single ' + offer.noun + (offer.count > 1 ? ' · ' + offer.extra + ' extra vs this pack' : '') : pct;
        const was = document.createElement('s'); was.textContent = money(variant.price * qty);
        const now = document.createElement('span'); now.textContent = money(sub.price * qty);
        els.priceSub.replaceChildren(was, ' ', now);
      } else {
        els.pct.textContent = '';
        els.pctText.textContent = '';
        els.priceSub.textContent = sub ? money(sub.price * qty) : 'Not available';
      }
      els.pct.hidden = !hasSubscriptionSaving(variant, sub);
      els.subSaving.hidden = !hasSubscriptionSaving(variant, sub);
      els.freq.hidden = !subscribed();
      // Auto-renewal disclosure under the button, same wording as the product page.
      const renewing = subscribed() && sub;
      els.renewal.textContent = renewing ? V.renewalText(sub, sub.price * qty, money) : '';
      els.renewal.hidden = !renewing;
    }

    // ---------- gallery ----------
    function renderGallery(scrollToVariant) {
      const product = state.product;
      const variant = currentVariant();
      const images = product.images.slice();
      if (variant.image && !images.some(src => baseName(src) === baseName(variant.image))) images.unshift(variant.image);
      const key = product.handle + '|' + images.map(baseName).join();
      if (state.galleryKey !== key) {
        const userSelection = !!state.galleryKey;
        const inViewport = root.getBoundingClientRect().top < window.innerHeight;
        state.galleryKey = key;
        const alts = product.imageAlts || [];
        const slides = images.map((src, i) => {
          const slide = document.createElement('div'); slide.className = 'alac-hb__slide';
          const img = document.createElement('img');
          img.alt = galleryAlt(product, alts, src, i, images.length);
          img.width = 900; img.height = 900;
          img.loading = galleryLoading(i === 0, userSelection, inViewport);
          img.decoding = 'async';
          img.sizes = '(min-width: 990px) 560px, 92vw';
          img.srcset = [360, 540, 720, 900].map(width => {
            const candidate = imageWidth(src, width);
            return candidate ? candidate + ' ' + width + 'w' : '';
          }).filter(Boolean).join(', ');
          img.src = src;
          slide.append(img);
          return slide;
        });
        els.track.replaceChildren(...slides);
        const buttons = images.length > 1 ? images.map((src, i) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'alac-hb__thumb'; button.dataset.i = String(i);
          button.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + images.length);
          const img = document.createElement('img');
          img.src = src.replace(/width=\d+/, 'width=160'); img.alt = '';
          img.width = 80; img.height = 80; img.loading = 'lazy';
          button.append(img);
          return button;
        }) : [];
        els.thumbs.replaceChildren(...buttons);
        els.dots.replaceChildren(...buttons.map((_, i) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'alac-hb__dot'; button.dataset.i = String(i);
          button.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + images.length);
          return button;
        }));
        els.track.tabIndex = images.length > 1 ? 0 : -1;
        els.track.setAttribute('aria-label', images.length > 1 ? 'Product images. Use the left and right arrow keys to change the image.' : 'Product image');
        els.track.scrollLeft = 0;
        markSlide(0);
      }
      if (scrollToVariant && variant.image) {
        const idx = images.findIndex(src => baseName(src) === baseName(variant.image));
        if (idx > -1) goSlide(idx, true);
      }
    }
    function goSlide(i, smooth) {
      const w = els.track.clientWidth;
      if (!w) return;
      const img = els.track.children[i]?.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
      els.track.scrollTo({ left: i * w, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
      markSlide(i);
    }
    function markSlide(i) {
      [...els.dots.children].forEach((d, k) => { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', String(k === i)); });
      [...els.thumbs.children].forEach((b, k) => b.setAttribute('aria-current', String(k === i)));
    }
    let scrollTimer;
    els.track.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(() => { const w = els.track.clientWidth; if (w) markSlide(Math.round(els.track.scrollLeft / w)); }, 80); }, { passive: true });
    els.thumbs.addEventListener('click', e => { const b = e.target.closest('[data-i]'); if (b) goSlide(Number(b.dataset.i), true); });
    els.track.addEventListener('keydown', e => {
      const n = els.track.children.length; if (n < 2) return;
      const cur = Math.round(els.track.scrollLeft / (els.track.clientWidth || 1));
      let j = null;
      if (e.key === 'ArrowRight') j = Math.min(n - 1, cur + 1);
      else if (e.key === 'ArrowLeft') j = Math.max(0, cur - 1);
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j === null) return;
      e.preventDefault(); goSlide(j, true);
    });
    els.dots.addEventListener('click', e => { const b = e.target.closest('[data-i]'); if (b) goSlide(Number(b.dataset.i), true); });
    // Chip rows scroll sideways on phones: make the scroller a labelled, focusable region only while it actually scrolls.
    root.querySelectorAll('.alac-chips').forEach(list => {
      if (list.parentElement.classList.contains('alac-hb__chips')) return;
      const wrap = document.createElement('div');
      wrap.className = 'alac-hb__chips';
      list.before(wrap); wrap.append(list);
    });
    function chipScroll() {
      root.querySelectorAll('.alac-hb__chips').forEach(wrap => {
        const scrolls = wrap.scrollWidth > wrap.clientWidth + 1;
        if (scrolls) { wrap.tabIndex = 0; wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-label', 'Product highlights'); }
        else { wrap.removeAttribute('tabindex'); wrap.removeAttribute('role'); wrap.removeAttribute('aria-label'); }
      });
    }

    // ---------- form sync ----------
    function syncForm() {
      const product = state.product;
      const variant = currentVariant();
      const sub = subscribed();
      els.id.value = String(variant.id);
      els.quantity.value = String(state.qty);
      els.planInput.disabled = !sub;
      els.planInput.value = sub ? String(state.planId) : '';
      root.dataset.variantId = String(variant.id);
      root.dataset.sellingPlan = sub ? String(state.planId) : '';
      const busy = root.getAttribute('aria-busy') === 'true';
      const label = !variant.available ? 'Sold out' : sub ? 'Start subscription' : 'Add to cart';
      if (!els.atc.classList.contains('loading')) {
        // The theme form marks the button sold out after any cart error (including a busy-store retry
        // message). A new selection gets a fresh button; the error text stays until the next add.
        const pf = els.atc.closest('product-form');
        const formKey = [product.handle, variant.id, state.qty, sub ? state.planId : 'once'].join(':');
        if (pf && pf.error && state.formKey !== formKey) {
          pf.error = false;
          els.atc.removeAttribute('aria-disabled');
          els.atc.querySelector('span').classList.remove('hidden');
          els.atc.querySelector('.sold-out-message')?.classList.add('hidden');
        }
        state.formKey = formKey;
        els.atc.querySelector('span').textContent = label;
        els.atc.disabled = busy || !variant.available;
      }
      els.details.href = detailsUrl(product.url, variant.id, state.qty, sub ? state.planId : null);
    }
    function renderAll(scrollToVariant) {
      // Multi-pack tiles represent complete packs. Never carry a hidden form
      // quantity from a single-variant stepper unless the custom editor is open.
      state.qty = orderQuantity(state.product, state.custom, state.qty);
      renderFormatGrind();
      renderPurchase();
      renderGuidance();
      renderQty(); // tile prices use the validated plan and purchase type
      renderGallery(scrollToVariant);
      syncForm();
      pushDelivery();
    }

    // The delivery card under the buy box (snippets/delivery-estimate.liquid) follows this buy box's
    // own state: the tab's product, the selected variant's grams and the Subscribe & Save plan. The
    // card then ignores AlacHBForm's fields, which only ever describe the first tab's product.
    function pushDelivery() {
      const card = root.querySelector('delivery-estimate');
      if (!card || typeof CustomEvent !== 'function') return;
      const variant = currentVariant();
      const plan = subscribed() ? variant.allocations.find(a => String(a.id) === String(state.planId)) : null;
      card.dispatchEvent(new CustomEvent('delivery-estimate:context', { detail: {
        variantId: variant.id, grams: variant.weight || 0, available: variant.available !== false,
        requiresShipping: variant.requiresShipping !== false, plan: plan ? String(plan.id) : '', planName: plan ? plan.name : '',
      } }));
    }

    // Announce the selected order after a shopper changes its price or purchase mode.
    // The initial render seeds the key without speaking a price on page load.
    const orderAnnouncer = createOrderAnnouncer(text => { els.orderStatus.textContent = text; });
    function currentOrder() {
      const variant = currentVariant();
      const isSubscription = subscribed();
      const plan = isSubscription ? variant.allocations.find(a => String(a.id) === String(state.planId)) : null;
      const count = state.qty;
      const selection = state.custom || singleQuantityProduct(state.product)
        ? count + ' ' + packNoun(state.product) + (count === 1 ? '' : 's')
        : pieceLabel(state.product, variant);
      const cadence = plan && window.AlacSubscriptionPricing?.weeks(plan.name);
      return orderSummary({ handle: state.product.handle, variantId: variant.id, quantity: count,
        subscription: isSubscription, planId: plan?.id, selection,
        unitPrice: plan?.price ?? variant.price, cadence }, money);
    }
    function announceOrder() {
      if (!els.orderStatus) return;
      orderAnnouncer.announce(currentOrder());
    }

    function selectDefaultVariant(product, keepCount) {
      state.variantId = defaultVariant(product, keepCount, V.packCount).id;
    }

    function setPending(pending) {
      if (pending) { root.setAttribute('aria-busy', 'true'); guidance.textContent = ''; }
      else root.removeAttribute('aria-busy');
      $('[data-hb-group="qty"]').inert = pending;
      $('[data-hb-group="purchase"]').inert = pending;
      els.status.classList.remove('is-error');
      els.status.classList.add('alac-hb__sr');
      els.status.textContent = pending ? 'Loading selection…' : '';
    }

    function setProduct(entry, opts) {
      const token = ++state.token;
      state.target = entry;
      const intent = opts?.selection || state.pendingSelection;
      const prevCount = intent ? intent.packCount : state.product ? state.custom ? state.previousPackCount : V.packCount(currentVariant().title) : null;
      const preserveCustomQuantity = intent ? intent.custom : customQuantityIntent(state.product, state.custom, state.qty);
      setPending(true);
      syncForm();
      return load(entry.handle).then(product => {
        if (token !== state.token) return;
        state.target = null;
        state.entry = entry;
        state.product = product;
        if (intent) {
          state.custom = intent.custom;
          state.qty = intent.qty;
          state.previousPackCount = intent.packCount;
          state.planName = intent.planName;
          els.sub.checked = intent.subscribed;
          els.once.checked = !intent.subscribed;
        }
        if (preserveCustomQuantity && !singleQuantityProduct(product)) state.custom = !!singleFor(product);
        if (state.custom) {
          const one = singleFor(product);
          if (one) state.variantId = one.id;
          else { state.custom = false; state.qty = 1; selectDefaultVariant(product, prevCount); }
        } else selectDefaultVariant(product, prevCount);
        if (singleQuantityProduct(product)) state.custom = false;
        state.pendingSelection = null;
        setPending(false);
        renderAll(false);
        announceOrder();
      }).catch(() => {
        if (token !== state.token) return;
        state.target = null;
        state.pendingSelection = null;
        setPending(false);
        renderAll(false);
        els.status.classList.remove('alac-hb__sr');
        els.status.classList.add('is-error');
        els.status.textContent = 'That option could not be loaded. Please try again.';
      });
    }

    function activateTab(i, focus) {
      if (i === state.tab && state.product) return;
      const previousEntry = state.target || state.entry;
      const intent = state.pendingSelection || {
        packCount: state.custom ? state.previousPackCount : V.packCount(currentVariant().title),
        custom: customQuantityIntent(state.product, state.custom, state.qty),
        qty: state.qty, subscribed: els.sub.checked, planName: state.planName
      };
      state.tab = i;
      els.tabs.forEach((t, k) => { const on = k === i; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      const tab = els.tabs[i];
      els.panel.setAttribute('aria-labelledby', tab.id);
      if (focus) tab.focus();
      const strip = tab.parentElement;
      const left = tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      els.intros.forEach(el => { el.hidden = el.dataset.hbIntro !== String(i); });
      chipScroll();
      const t = tabData();
      // Reflect the tab's own product immediately; it is inline, so this renders without waiting.
      state.entry = t.self;
      state.product = t.product;
      state.custom = intent.custom && !singleQuantityProduct(state.product) && !!singleFor(state.product);
      state.qty = intent.custom && (state.custom || singleQuantityProduct(state.product)) ? intent.qty : 1;
      state.previousPackCount = intent.packCount;
      state.planName = intent.planName;
      els.sub.checked = intent.subscribed;
      els.once.checked = !intent.subscribed;
      state.token++;
      state.target = null;
      setPending(false);
      if (state.custom) state.variantId = singleFor(state.product).id;
      else selectDefaultVariant(state.product, intent.packCount);
      renderAll(false);
      const wanted = matchingRelated(t.related, previousEntry);
      if (wanted && wanted.handle !== state.entry.handle) {
        state.pendingSelection = intent;
        setProduct(wanted, { selection: intent });
      } else { state.pendingSelection = null; announceOrder(); }
    }

    // Warm only the product under the shopper's pointer or keyboard focus.
    // Entering the choices no longer fans out requests for every related product.
    function prefetchChoice(event) {
      const choice = event.target.closest('[data-hb-opts="format"] input, [data-hb-opts="grind"] input, [data-hb-opts="format"] label, [data-hb-opts="grind"] label');
      if (!choice) return;
      const input = choice.tagName === 'LABEL' ? document.getElementById(choice.htmlFor) : choice;
      if (!input || input.disabled || input.checked) return;
      const group = input.name === uid + '-format' ? 'format' : 'grind';
      const entry = relatedChoice(tabData().related, state.target || state.entry, group, input.value, tabData().self.grind);
      if (entry) load(entry.handle).catch(() => {});
    }
    ['pointerover', 'focusin'].forEach(type => $('[data-hb-choices]').addEventListener(type, prefetchChoice, { passive: true }));

    // ---------- events ----------
    els.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activateTab(i, false));
      tab.addEventListener('keydown', e => {
        const n = els.tabs.length;
        let j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % n;
        else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = n - 1;
        if (j === null) return;
        e.preventDefault();
        activateTab(j, true);
      });
    });

    root.addEventListener('change', e => {
      const input = e.target;
      const t = tabData();
      const changingProduct = input.name === uid + '-format' || input.name === uid + '-grind';
      if (root.getAttribute('aria-busy') === 'true' && !changingProduct) return;
      if (input.name === uid + '-format') {
        const entry = relatedChoice(t.related, state.target || state.entry, 'format', input.value, t.self.grind);
        if (entry) setProduct(entry, {});
      } else if (input.name === uid + '-grind') {
        const entry = relatedChoice(t.related, state.target || state.entry, 'grind', input.value, t.self.grind);
        if (entry) setProduct(entry, {});
      } else if (input.name === uid + '-qty') {
        state.custom = false; state.qty = 1;
        state.variantId = Number(input.value);
        state.previousPackCount = V.packCount(currentVariant().title);
        renderAll(true);
        announceOrder();
      } else if (input.name === 'tabinner') {
        renderAll(false);
        announceOrder();
      } else if (input === els.plan) {
        state.planId = Number(els.plan.value);
        renderAll(false);
        announceOrder();
      } else if (input === els.qtyInput) {
        state.qty = Math.min(24, Math.max(1, parseInt(els.qtyInput.value, 10) || 1));
        renderAll(false);
        announceOrder();
      }
    });
    root.querySelectorAll('[data-hb-step]').forEach(btn => btn.addEventListener('click', () => {
      if (root.getAttribute('aria-busy') === 'true') return;
      state.qty = Math.min(24, Math.max(1, state.qty + Number(btn.dataset.hbStep)));
      renderAll(false);
      announceOrder();
    }));
    els.other.addEventListener('click', () => {
      if (root.getAttribute('aria-busy') === 'true') return;
      state.custom = !state.custom;
      if (state.custom) {
        state.previousPackCount = V.packCount(currentVariant().title);
        state.variantId = singleFor(state.product).id;
        state.qty = 2;
      } else { state.qty = 1; selectDefaultVariant(state.product, state.previousPackCount); }
      renderAll(true);
      announceOrder();
      if (state.custom) els.qtyInput.focus();
    });
    root.addEventListener('submit', event => {
      if (root.getAttribute('aria-busy') !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => entries.forEach(en => document.documentElement.classList.toggle('alac-hb-visible', en.isIntersecting)), { rootMargin: '0px 0px -10% 0px' }).observe(root);
    }
    // Sticky gallery clears the theme header (its height varies with the announcement bar).
    function stickyTop() {
      const header = document.querySelector('.section-header, sticky-header, .shopify-section-header-sticky');
      const h = header ? Math.max(0, Math.min(200, header.getBoundingClientRect().height)) : 80;
      root.style.setProperty('--hb-sticky-top', (h + 24) + 'px');
    }
    stickyTop();
    window.addEventListener('resize', stickyTop, { passive: true });
    // The delivery range under the buy box is the shared <delivery-estimate> component (assets/delivery-estimate.js).

    // Initial render for the first tab, synchronously, before first paint.
    state.entry = tabData().self;
    state.product = tabData().product;
    selectDefaultVariant(state.product, null);
    root.classList.add('is-ready');
    renderAll(false);
    orderAnnouncer.prime(currentOrder());
    chipScroll();
    window.addEventListener('resize', chipScroll, { passive: true });
    let bandTimer;
    window.addEventListener('resize', () => { clearTimeout(bandTimer); bandTimer = setTimeout(equalizeBands, 120); }, { passive: true });
    window.addEventListener('resize', () => { const w = els.track.clientWidth; const i = [...els.dots.children].findIndex(d => d.classList.contains('is-on')); if (w && i > 0) els.track.scrollLeft = i * w; }, { passive: true });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalize, requestProduct, detailsUrl, imageWidth, galleryLoading, relatedChoice, FALLBACK, handleFromUrl, galleryAlt, escapeHtml, visibleVariants, availableSingle, hasSteepSingle, singleQuantityProduct, defaultVariant, matchingRelated, quantityTiles, comparableSavings, customQuantityIntent, orderQuantity, hasSubscriptionSaving, orderSummary, createOrderAnnouncer };
    return;
  }
  document.querySelectorAll('[data-alac-hb]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-alac-hb]').forEach(init));
})();
